module.exports = __webpack_public_path__ + "static/media/HR.5dbad14f.svg";